module.exports = __webpack_public_path__ + "olr-mainfe/styles/bootstrap/fonts/glyphicons-halflings-regular.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/olr-mainfe/styles/bootstrap/fonts/glyphicons-halflings-regular.woff
 ** module id = 44
 ** module chunks = 1
 **/